import { createFileRoute } from '@tanstack/react-router'

import { UnauthorizedPage } from '@/pages/unauthorized'

export const Route = createFileRoute('/unauthorized-page')({
  component: RouteComponent,
})

export const UnauthorizedPageRoute = Route

function RouteComponent() {
  return <UnauthorizedPage />
}
